import type {
  GameTypeData,
  GameTypesTableColumns
} from '@library/types/gameTypes';
import type { TableColumn } from '@library/types/utils';

export const GAME_TYPES_TABLE_HEADER: Array<
  TableColumn<GameTypesTableColumns>
> = [
  {
    column: 'checkbox',
    essential: true,
    label: '',
    sortEnabled: false,
    width: 'w-[3%] px-3'
  },
  {
    column: 'id',
    essential: true,
    label: 'ID',
    sortEnabled: true,
    width: 'w-[10%] px-3'
  },
  {
    column: 'name',
    essential: true,
    label: 'Name',
    sortEnabled: true,
    width: 'w-[25%] px-3'
  },
  {
    column: 'description',
    essential: true,
    label: 'Description',
    sortEnabled: true,
    width: 'w-[35%] px-3'
  },
  {
    column: 'created_at',
    essential: true,
    label: 'Created At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  },
  {
    column: 'updated_at',
    essential: true,
    label: 'Updated At',
    sortEnabled: true,
    width: 'w-[15%] px-3'
  }
];

export const DEFAULT_GAME_TYPE_DATA: GameTypeData = {
  createdAt: '',
  id: '',
  name: '',
  updatedAt: '',
  description: ''
};
